module.exports = __webpack_public_path__ + "static/media/nuru2.a04f22c2.png";